// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var purple = (_obj = {}, _define_property(_obj, 50, '#F4F1FE'), _define_property(_obj, 100, '#EAE3FC'), _define_property(_obj, 200, '#DBD0FA'), _define_property(_obj, 300, '#CAB9F8'), _define_property(_obj, 400, '#B9A2F6'), _define_property(_obj, 500, '#A588F7'), _define_property(_obj, 600, '#825AEF'), _define_property(_obj, 700, '#6C47D1'), _define_property(_obj, 800, '#532EB7'), _define_property(_obj, 900, '#371F7A'), _define_property(_obj, 950, '#1D1041'), _obj);

//# sourceMappingURL=purple.js.map